import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';
import { ICapSuaChuaResponseBase } from '@/core/interfaces/ApiResponses';
import { CapSuaChuaService } from '@/core/services/CapSuaChuaService.service';
import { swalErrNotification } from '@/core/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CapSuaChuaSearchInput',
  props: {
  fullWidth: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: null,
  },
  propName: {
    type: String,
    default: 'id_cap_sua_chua',
  },
  valueKey: {
    type: String,
    default: 'ten_cap_sc',
  },
  placeholder: {
    type: String,
    default: 'Chọn cấp sửa chữa',
  },
},
  emits: ["clear", "select"],
  setup(__props, { emit: __emit }) {

const props = __props;

const tenCapSuaChua = ref<string>('');
const selectedId = ref<number | null>(props.id);

watch(() => props.id, async (newId, previousId) => {
  if (newId && !previousId) {
    try {
      const {
        data: {
          data: {
            ten_cap_sc,
          }
        }
      } = await CapSuaChuaService.get(newId);

      tenCapSuaChua.value = ten_cap_sc;
    } catch (error) {
      await swalErrNotification(error, 'Có lỗi xảy ra');
    }
  }
});

const emits = __emit;

const query = async (queryString: string, cb: (results: ICapSuaChuaResponseBase[]) => void) => {
  try {
    const {
      data: {
        data: {
          data
        }
      }
    } = await CapSuaChuaService.list({ s: queryString, per_page: 1000 });

    cb(data);
  } catch (error) {
    await swalErrNotification(error, 'Có lỗi xảy ra');
  }
};

const handleOptionSelected = ({ id, ten_cap_sc }: ICapSuaChuaResponseBase) => {
  selectedId.value = id;
  tenCapSuaChua.value = ten_cap_sc;
  emits('select', { id, ten_cap_sc });
}

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    class: _normalizeClass(["mb-0", { 'w-full': __props.fullWidth }]),
    prop: __props.propName
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_autocomplete, {
        modelValue: tenCapSuaChua.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenCapSuaChua).value = $event)),
        class: _normalizeClass({ 'w-full': __props.fullWidth }),
        clearable: "",
        "fetch-suggestions": query,
        "highlight-first-item": "",
        name: __props.propName,
        placeholder: __props.placeholder,
        "trigger-on-focus": false,
        "value-key": __props.valueKey,
        onClear: _cache[1] || (_cache[1] = () => {
        selectedId.value = null;
        tenCapSuaChua.value = '';
        emits('clear');
      }),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select())),
        onSelect: handleOptionSelected
      }, {
        default: _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(item[__props.valueKey]), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "class", "name", "placeholder", "value-key"])
    ]),
    _: 1
  }, 8, ["class", "prop"]))
}
}

})